import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';

let isSentryInitialized = false;

const integrations = [
  Sentry.reactRouterV7BrowserTracingIntegration({
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
  }),
];

export type UseSentryInitOptions = {
  dsn?: string;
  environment?: string;
  release?: string;
  account_id?: string;
};

/**
 * See https://docs.sentry.io/platforms/javascript/guides/react/features/react-router/v7/ for configuration
 */
export function useSentryInit({
  dsn,
  environment = 'development',
  release,
  account_id,
}: UseSentryInitOptions) {
  useEffect(() => {
    if (dsn && release) {
      if (!isSentryInitialized) {
        Sentry.init({
          dsn,
          environment,
          release,
          tracesSampleRate: 1,
          integrations,
          initialScope(scope) {
            if (account_id) {
              scope.setUser({ id: account_id });
            }
            return scope;
          },
        });

        isSentryInitialized = true;
      } else {
        if (account_id) {
          Sentry.setUser({ id: account_id });
        } else {
          Sentry.setUser(null);
        }
      }
    }
  }, [account_id, dsn, environment, release]);
}
